import React from  "react";


const Payment: React.FC = () => {
  return <p>Payment</p>
};

export default Payment;
